import AxiosGet from '../../../axios/get'
// import axios from 'axios'
// import log from '../../logger/elastic-console'
import stat from '../../../shared/constant'

const grade = {
  getGrade: async () => {
    const response = await AxiosGet(stat.URL_GRADE)
    return response
  }
}

export default grade
